import { useCallback } from 'react';
import { useGetReminderDateTime } from '../../../components';
import type { CreateEventData } from '../../../queries';
import type { CreateReminderFormValues } from '../CreateReminderForm';

export const useCreateFormRequestData = () => {
  const getReminderDateTime = useGetReminderDateTime();

  return useCallback(
    (formValues: CreateReminderFormValues): CreateEventData => {
      const { endTime, startTime } = getReminderDateTime(formValues);

      return {
        allDay: formValues.isAllDay,
        distributionList: formValues.invitations
          ?.filter((invitation) => invitation.type === 'community')
          .map((invitation) => ({
            communityId: invitation.value,
            communityName: invitation.label,
          })),
        endTime: endTime.toISOString(),
        html: formValues.htmlDescription,
        name: formValues.name,
        participants:
          formValues.invitations
            ?.filter((invitation) => invitation.type === 'user')
            .map((invitation) => ({
              ref: invitation.value,
              role: 'attendee',
              type: 'user',
            })) ?? [],
        startTime: startTime.toISOString(),
        text: formValues.textDescription,
        type: 'reminder',
      };
    },
    [getReminderDateTime],
  );
};
